module.exports = __webpack_public_path__ + "img/20191209_111548-1.871caad9.jpg";